/*global $*/
/*eslint no-undef: "error"*/
export default class SectionButtons {
    classItem = 'section-buttons--item'
    classButton = 'section-buttons--button'

    classItemOpen = 'section-buttons-open'
    classButtonOpen = 'section-block-open'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            $(`.${self.classItem}`).toggleClass(self.classItemOpen)
            $(this).toggleClass(self.classButtonOpen)
        })
    }
}
